export enum CompleteDialogAction {
  Complete,
  Save,
  Cancel,
}
